/*
 * OLAPLEX — Banner con slides (sections/olaplex-banner-slides.liquid).
 * El carrusel en sí es el slideshow-component de Dawn (global.js); acá solo se
 * manejan los videos: cada <video> trae su mp4 en data-src y se carga recién
 * cuando su slide está activo y el banner está en pantalla. Solo se reproduce el
 * video visible en el ancho actual (web o móvil); los demás quedan en pausa.
 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const isShown = (video) => video.offsetParent !== null && getComputedStyle(video).display !== 'none';

  function init(root) {
    if (root.dataset.olxBsReady) return;
    root.dataset.olxBsReady = 'true';

    const slides = () => Array.from(root.querySelectorAll('.slideshow__slide'));
    let current = 0;
    let onScreen = false;

    const sync = () => {
      slides().forEach((slide, i) => {
        slide.querySelectorAll('video.olx-bs__video').forEach((video) => {
          const play = i === current && onScreen && isShown(video) && !reducedMotion.matches;
          if (!play) {
            if (!video.paused) video.pause();
            return;
          }
          if (!video.getAttribute('src') && video.dataset.src) {
            video.src = video.dataset.src;
            video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
          }
          const p = video.play();
          if (p && p.catch) p.catch(() => {}); // autoplay bloqueado (ahorro de batería): queda la imagen
        });
      });
    };

    root.addEventListener('slideChanged', (event) => {
      current = (event.detail && event.detail.currentPage ? event.detail.currentPage : 1) - 1;
      sync();
    });

    // El editor de temas selecciona slides con eventos propios: seguir el que quedó visible.
    root.addEventListener('shopify:block:select', (event) => {
      const i = slides().indexOf(event.target);
      if (i >= 0) {
        current = i;
        sync();
      }
    });

    new IntersectionObserver(
      (entries) => {
        onScreen = entries[0].isIntersecting;
        sync();
      },
      { threshold: 0.15 }
    ).observe(root);

    window.matchMedia('(max-width: 749px)').addEventListener('change', sync);
    reducedMotion.addEventListener('change', sync);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) root.querySelectorAll('video.olx-bs__video').forEach((v) => v.pause());
      else sync();
    });
  }

  const start = () => document.querySelectorAll('[data-olx-banner-slides]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
